<mat-card>
  <h2 translate>activityPanel.title</h2>
  <p translate>activityPanel.text</p>

  <mat-card-content>
    <form [formGroup]="searchDataForm">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <mat-checkbox fxFlex="100" class="monthCheckBox" (change)="sendDateMonth($event)">
          <mat-label translate>sidenav.menu.reports.current-month</mat-label>
        </mat-checkbox>
        <div fxFlex="50" fxFlex.gt-sm="40">
          <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
            <mat-label translate>request.search.label.initialDate</mat-label>
            <input
              #inputInitialDate
              id="inputInitialDate"
              matInput
              [matDatepicker]="datepickerInitialDate"
              formControlName="initialDate"
              [min]="minDate"
              [max]="currentDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerInitialDate"></mat-datepicker-toggle>
            <mat-datepicker
              id="datepickerInitialDate"
              startView="multi-year"
              #datepickerInitialDate
              (monthSelected)="chosenMonthHandler($event, datepickerInitialDate, inputInitialDate)"
              (yearSelected)="chosenYearHandler($event, inputInitialDate)"
            >
            </mat-datepicker>
            <mat-error *ngIf="searchDataForm.controls.initialDate.errors?.required" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="searchDataForm.controls.initialDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
            <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="40">
          <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
            <mat-label translate>request.search.label.finalDate</mat-label>
            <input
              #inputFinalDate
              id="finalDateSearchPanel"
              matInput
              [matDatepicker]="datepickerFinalDate"
              formControlName="finalDate"
              [max]="maxFinalDate"
              [min]="minFinalDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerFinalDate"></mat-datepicker-toggle>
            <mat-datepicker
              id="datepickerFinalDate"
              startView="multi-year"
              #datepickerFinalDate
              (monthSelected)="chosenMonthHandler($event, datepickerFinalDate, inputFinalDate)"
              (yearSelected)="chosenYearHandler($event, inputFinalDate)"
            >
            </mat-datepicker>
            <mat-error *ngIf="searchDataForm.controls.finalDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
            <mat-error *ngIf="searchDataForm.controls.finalDate.errors?.required" translate> field.required </mat-error>
            <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateFinal</mat-error>
            <mat-error *ngIf="searchDataForm.controls.finalDate.hasError('matDatepickerMax')" translate
              >activityPanel.maxDate.error</mat-error
            >
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.gt-sm="1 0 auto" fxLayoutAlign="end" fxFlexAlign="start" fxLayoutAlign.gt-sm="start">
          <button
            id="searchRequestSearchPanel"
            mat-flat-button
            type="button"
            color="accent"
            class="search__button--request"
            (click)="onFilterClick()"
            [disabled]="!searchDataForm.valid && !checkedDateMonth"
          >
            <span>{{ 'activityPanel.btnFilterData' | translate | uppercase }}</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="loadgraphic">
  <h2 translate>activityPanel.chart.title</h2>

  <p translate>activityPanel.chart.text</p>
  <div style="display: block">
    <canvas
      baseChart
      [data]="barChartData"
      [labels]="barChartLabels"
      [options]="barChartOptions.options"
      [legend]="barChartLegend"
      [type]="barChartType"
    >
    </canvas>
  </div>
</mat-card>
